/** Production and test Fountain Life accounts use the members-first UX. */
export function isFountainLifeAccountId(
  accountId: string | null | undefined,
): boolean {
  return !!accountId?.startsWith('fountainlife');
}
